import '../scss/Listview.css';

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import Appbrick from './Appbrick';
import RichContentHelper from './helper/richcontent-helper';
import { loadImage } from './helper/image-loader';
import UserInterfaceHelper from './helper/user-interface-helper';

const PREFIX = 'LISTVIEW';
const LAZY_LOAD_NUM = 5;

class Listview extends PureComponent {
  constructor(props) {
    super();
    const { tabOrder, appOrder } = UserInterfaceHelper.lastAppsviewIndex;
    const readLastIndex = appOrder && props.order === tabOrder;
    this.navDirection = 1;
    this.state = {
      currentBrickIndex: readLastIndex ? appOrder : 0,
      apps: [],
      initialized: props.isCurrentList,
      lastLoadedBrickIndex: readLastIndex ? appOrder : 0
    };
  }

  componentWillMount() {
    this.setState({
      apps: this.getApps()
    });
  }

  componentWillUnmount() {
    if (this.props.isCurrentList) {
      UserInterfaceHelper.lastAppsviewIndex.appOrder = this.state.currentBrickIndex;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currentCategory = this.props.category;
    if (prevProps.category !== currentCategory) {
      this.setState({
        apps: this.getApps()
      });
    }
    if (prevState.currentBrickIndex !== this.state.currentBrickIndex) {
      const promotion = document.getElementById('promotion-bar');
      if (this.state.currentBrickIndex > this.state.lastLoadedBrickIndex) {
        this.setState({ lastLoadedBrickIndex: this.state.currentBrickIndex });
      }
      if (this.state.currentBrickIndex === 0 && promotion) {
        // if promotion banner exists, we should reset currentIndex.
        promotion.focus();
      } else {
        this._focus();
      }
    }
    if (this.props.isCurrentList && this.state.initialized === false) {
      this.setState({
        initialized: true
      });
    }
    if (prevState.initialized === false && this.state.initialized === true) {
      this._focus();
    }
  }

  getApps() {
    const category = this.props.category;
    const allApps = this.props.apps;
    if (typeof category === undefined) {
      return [];
    }
    if (category === 'all') {
      return allApps;
    }
    if (category === 'recommended') {
      // When recommended_index > 0, we will show this app in the recommendation tab,
      // and the list will also be sorted by recommended_index.
      return allApps
        .filter(app => !!app.remoteInfo['recommended_index'])
        .sort(this._sortRecommendationApps);
    }

    return allApps.filter(app => {
      return app.remoteInfo.category === category;
    });
  }

  _sortRecommendationApps(app1, app2) {
    return app1['recommended_index'] - app2['recommended_index'];
  }

  _nav(move, e) {
    const brickNumber = this.state.apps.length;
    let nextIndex = parseInt(this.state.currentBrickIndex, 10) + move;
    this.navDirection = move;

    if (nextIndex < 0) {
      this.setState({ currentBrickIndex: 0 });
    } else if (nextIndex < brickNumber) {
      nextIndex %= brickNumber;
      this.setState({ currentBrickIndex: nextIndex });
    }
    e.stopPropagation();
  }

  handleKeydown = e => {
    switch (e.key) {
      case 'ArrowUp':
        this._nav(-1, e);
        break;
      case 'ArrowDown':
        this._nav(1, e);
        break;
      case 'ArrowRight':
      case 'ArrowLeft':
      case 'BrowserBack':
      case 'Accept':
      case 'Enter':
      default:
        // do nothing, pass to parent.
        break;
    }
  };

  _focus() {
    const currentIndex = this.state.currentBrickIndex;
    const brick = this.element.querySelectorAll('.brick')[currentIndex];

    if (brick) {
      brick.focus();
      brick.scrollIntoView({
        // set vertical alignment to bottom when moving upwards and vice versa
        // to ensure the component could be shown completely
        block: this.navDirection > 0 ? 'end' : 'start'
      });
    }
  }

  handleFocus = e => {
    this._focus();
  };

  handleBrickFocus = () => {
    if (RichContentHelper.enable) {
      loadImage(
        this.element.querySelectorAll('.brick')[this.state.currentBrickIndex],
        'bg'
      );
    }
  };

  render() {
    const { apps, lastLoadedBrickIndex } = this.state;
    const category = this.props.category;
    const hasProgressBar = category !== 'recommended';
    var renderApps = [];

    if (this.state.initialized) {
      renderApps = apps.slice(0, lastLoadedBrickIndex + LAZY_LOAD_NUM);
    }
    return (
      <div
        className="Listview"
        tabIndex="1"
        onKeyDown={this.handleKeydown}
        onFocus={this.handleFocus}
        ref={target => {
          this.element = target;
        }}
      >
        <div className="container">
          {renderApps.map((result, index) => (
            <Appbrick
              key={PREFIX + '-' + result.id}
              data-id={result.id}
              appOrder={index}
              app={result.brickInfo}
              mozAPP={result.mozAPP}
              hasProgressBar={hasProgressBar}
              focusHandler={this.handleBrickFocus}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default Listview;



/** WEBPACK FOOTER **
 ** ./src/Listview.js
 **/